<template>
    <div class="banner">
        <swiper :options="swiperOption" ref="swiperRef" style="width: 100%;height: 100%;">
            <swiper-slide v-for="(item, i) in bannerList" :key="i" ref="mySwiper">
                <div style="width: 100%;height: 100%;position: relative;">
                    <!-- PinjieImgUrl + item.banner -->
                    <img :src="PinjieImgUrl + item.banner" alt="" style="width: 100%;height: 100%;object-fit: cover;">
                    <div class="flex-column box1">
                        <!-- {{ item.title }} -->
                        <div class="slide-title animate-text SourceHanSansCN-Bold" style="">
                            {{ item.title }}
                        </div>
                        <!-- <div class="slide-title animate-text SourceHanSansCN-Bold" style="">
                            {{ item.title2 }}</div> -->
                        <div class="slide-desc animate-text SourceHanSansCN-Regular" style="">
                            {{ item.content }}</div>
                        <div class="but_div">
                            <a class="slide-btn animate-btn SourceHanSansCN-Regular" :href="item.link" style="">
                                了解详情<i data-v-5d8455b6="" class="el-icon-top-right" style="margin-left: 30px;"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <div class="swiper-pagination_one" slot="pagination"></div>
        </swiper>
    </div>
</template>

<script>
import { listBjlfbanner } from "@/api/system/bjlfbanner";//读取北京鲁飞banner图列表
import { listBjlfmenu } from "@/api/system/bjlfmenu"//读取北京鲁飞菜单列表

import { mapState } from "vuex";
export default {
    name: "SwiperTemp",
    // props: ['bannerList'],
    data() {
        return {
            // banner图查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                menuId: null,
            },
            // 菜单列表参数
            queryParamsMenu: {
                pageNum: 1,
                pageSize: 10000,
                menuName: null,
                parentId: null,
                orderNum: null,
            },
            bannerList: [
                // {
                //     img: require('../../assets/img/home1/ico_solution_1.png'),
                //     title: '车底安全检查系统',
                //     text: '完整成像无遗漏·图像清晰无畸变',
                //     link: '/cpzx?cid=3'
                // },
                // {
                //     img: require('../../assets/img/home1/img_home_banner_1.jpg'),
                //     title: '鲁飞科技',
                //     title2: '科技引领未来',
                //     text: '坚守创新、卓越、服务的理念，用科技守护世界每一刻的安全',
                //     link: '/cpzx?cid=4'
                // },
            ],
            swiperOption: {
                notNextTick: false,
                loop: false,
                touchRatio: 2, // 触摸滑动的顺畅度
                initialSlide: 0, // 默认展示页
                // 【修复1：删除重复的 autoplay: true，保留完整对象配置】
                autoplay: {
                    delay: 4000, // 自动轮播间隔（可调整）
                    disableOnInteraction: true, // 核心：用户交互后不停止自动轮播
                    pauseOnMouseEnter: true, // 鼠标悬停暂停，离开恢复
                    waitForTransition: true, // 等待过渡动画完成后再轮播
                    stopOnLastSlide: false, // 非循环模式下，到最后一张不停止（根据需求调整）
                },
                speed: 100, //切换动画速度（毫秒）
                slidesPerView: 'auto',
                centeredSlides: true,
                paginationClickable: true,
                clickable: true, // 允许点击指示器切换
                spaceBetween: 0, // 模块之间的间隔
                effect: 'fade', // 淡入淡出效果
                fadeEffect: {
                    crossFade: false // 交叉淡入淡出
                },
                on: {
                    // 【修复2：优化滑动事件，兼容fade效果】
                    slideChangeTransitionStart: function () {
                        const activeSlide = this.slides[this.activeIndex];
                        if (activeSlide) {
                            const textElements = activeSlide.querySelectorAll('.animate-text');
                            const btnElements = activeSlide.querySelectorAll('.animate-btn');
                            textElements.forEach(el => el.style.animation = 'none');
                            btnElements.forEach(el => el.style.animation = 'none');
                        }
                    },
                    slideChangeTransitionEnd: function () {
                        setTimeout(() => {
                            const activeSlide = this.slides[this.realIndex];
                            if (activeSlide) {
                                const textElements = activeSlide.querySelectorAll('.animate-text');
                                const btnElements = activeSlide.querySelectorAll('.animate-btn');
                                textElements.forEach(el => el.style.animation = '');
                                btnElements.forEach(el => el.style.animation = '');
                            }
                        }, 10);
                        // 【修复3：兼容fade效果的autoplay重启】
                        if (!this.autoplay.running) { // 仅当自动轮播停止时才重启
                            this.autoplay.start();
                        }
                    },
                    // 【新增：手动触摸结束后强制重启自动轮播（关键）】
                    touchEnd: function () {
                        this.autoplay.start();
                    },
                    // 【新增：点击分页器后重启自动轮播】
                    paginationClick: function () {
                        this.autoplay.start();
                    }
                },
                pagination: {
                    el: '.swiper-pagination_one',
                    clickable: true, // 允许点击指示器切换
                    bulletClass: 'my-bullet', // 自定义指示器类名
                    bulletActiveClass: 'my-bullet-active' // 激活态类名
                },
                // 【新增：解决触摸滑动后autoplay失效的兜底配置】
                allowTouchMove: true,
                preventInteractionOnTransition: false // 过渡动画时允许交互，避免阻断autoplay
            },
            menuArr: [],
            swiperInstance: null,

        }
    },
    watch: {
        Menuid: {
            handler(newVal, oldVal) {
                // console.log(newVal, oldVal, 'newValMenuid111123')
                this.getMenuList();
            },
            deep: true,
            immediate: true,
        }
    },
    computed: {
        ...mapState({
            Menuid: state => state.lufei.Menuid,
        })
    },
    mounted() {
        this.getMenuList();

    },
    methods: {
        getMenuList() {
            // console.log('sssssssssss')
            listBjlfmenu(this.queryParamsMenu).then(response => {
                this.menuArr = this.handleTree(response.rows, "menuId");
                // console.log(this.menuArr, '北京鲁飞菜单列表')
                //通过菜单列表第一项的menuId获取banner列表
                this.getList(this.menuArr[0].menuId);
            }).catch(error => {
                console.log(error, '北京鲁飞菜单列表失败')
                this.loading = false
            })

        },
        /** 查询北京鲁飞banner图列表 */
        async getList(menuId) {
            // console.log(this.Menuid, 'Menuid1111000')
            this.queryParams.menuId = menuId;
            // console.log(this.queryParams, 'queryParams1111000')
            const response = await listBjlfbanner(this.queryParams);
            // console.log(response, '789789897789789')
            this.bannerList = response.rows;
            // 等待 Swiper 初始化完成
            this.$nextTick(() => {
                const bullets = document.querySelectorAll('.my-bullet');
                bullets.forEach(bullet => {
                    // 创建左侧线段
                    const lineLeft = document.createElement('div');
                    lineLeft.className = 'line-left';
                    // 创建右侧线段
                    const lineRight = document.createElement('div');
                    lineRight.className = 'line-right';
                    // 插入到指示器中
                    bullet.appendChild(lineLeft);
                    bullet.appendChild(lineRight);
                });
            });
        },
    }
}
</script>
<style lang="less" scoped>
.but_div {
    margin: 0px;
    text-align: center;
    padding-left: 256px;
    box-sizing: border-box;
}

.slide-title {
    opacity: 0;
    transform: translateY(100px);
    font-size: 60px;
    font-weight: bold;
    color: #FFFFFF;
    padding-left: 256px;
    box-sizing: border-box;
    // background: red;
    // width: 100%;
}

.slide-desc {
    opacity: 0;
    font-size: 24px;
    transform: translateY(100px);
    color: #fff;
    margin-bottom: 40px;
    padding-left: 256px;
    box-sizing: border-box;
}

.slide-btn {
    opacity: 0;
    /* 初始状态不可见 */
    transform: translateX(-100px);
    /* 按钮初始位置在左侧 */
}

/* 1. 文字从上方落下的动画 */
@keyframes fadeInDown {
    from {
        opacity: 0;
        transform: translateY(-100px);
        /* 起始位置在上方 */
    }

    to {
        opacity: 1;
        transform: translateY(0);
        /* 结束位置在原位置 */
    }
}

/* 2. 按钮从左侧滑入的动画 */
@keyframes fadeInLeft {
    from {
        opacity: 0;
        transform: translateX(-100px);
        /* 起始位置在左侧 */
    }

    to {
        opacity: 1;
        transform: translateX(0);
        /* 结束位置在原位置 */
    }
}

/* --- 动画触发 --- */

/* 为 .animate-text 元素应用 fadeInDown 动画 */
::v-deep .swiper-slide-active .animate-text {
    animation: fadeInDown .5s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

/* 为 .animate-btn 元素应用 fadeInLeft 动画 */
::v-deep .swiper-slide-active .animate-btn {
    animation: fadeInLeft .5s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

/* --- 为不同元素设置动画延迟，创建序列感 --- */

/* 标题先出现 */
::v-deep .swiper-slide-active .slide-title {
    animation-delay: 0.2s;
}

/* 描述文字接着出现 */
::v-deep .swiper-slide-active .slide-desc {
    animation-delay: 0.3s;
}

/* 按钮最后出现 */
::v-deep .swiper-slide-active .slide-btn {
    animation-delay: 0.4s;
}


.banner {
    width: 100%;
    height: 800px;

    a {
        position: relative;
        display: flex;
        width: 180px;
        height: 50px;
        text-align: center;
        border: 1px solid #FFFFFF;
        overflow: hidden;
        align-items: center;
        font-size: 20px;
        justify-content: center;
        /* 关键：背景渐变和过渡动画 */
        background: linear-gradient(36deg, #fff 50%, transparent 50%);
        background-size: 284% 200%;
        /* 背景尺寸扩大到200% */
        background-position: 100% 100%;
        /* 初始位置在右下角（透明部分在上左） */
        transition:
            background-position 0.5s ease,
            /* 背景位置变化的过渡 */
            color 0.3s ease;
        /* 文字颜色变化的过渡 */
    }

    a:hover {
        // transition: all 0.3s;
        // border: 1px solid #004CA6;
        // background: #fff;
        color: #004CA6;
        background-position: 0% 0%;
        /*  hover 时，将背景位置移动到左上角 */
        /* 文字颜色变为白色 */
        /* Hover时动画：展开 */
        /* Hover时动画：展开 */
    }

    .box1 {
        width: 100%;
        position: absolute;
        top: 50%;
        left: 0%;
        transform: translate(0%, -50%);
    }

    .box2 {
        position: absolute;
        top: 30%;
        left: 50%;
        transform: translate(-30%, -50%);
    }

    .box3 {
        position: absolute;
        top: 20%;
        left: 13%;

        a {
            margin: 0;
        }
    }
}

/* 定义展开动画 */
@keyframes bg-expand {
    from {
        background-position: 0% 100%;
        /* 从左下角开始 */
    }

    to {
        background-position: 0% 0%;
        /* 到整个元素铺满结束 */
    }
}

/* 定义缩回动画 */
@keyframes bg-retract {
    from {
        background-position: 0% 0%;
        /* 从整个元素铺满开始 */
    }

    to {
        background-position: 0% 100%;
        /* 到左下角结束 */
    }
}


/* 分页器容器：居中显示 */
.swiper-pagination_one {
    // width: 100px;
    // height: 40px;
    // background: red;
    position: absolute;
    bottom: 30px;
    /* 距离底部距离 */
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    gap: 80px;
    z-index: 9;
    /* 指示器之间的间距 */

}

/* 基础指示器样式（未激活态） */
::v-deep .my-bullet {
    position: relative;
    width: 30px;
    height: 30px;
    opacity: 1;
    /* 取消默认透明度 */
    background: transparent;
    /* 清除默认背景 */
    cursor: pointer;
}

/* 环形外圈（未激活态） */
::v-deep .my-bullet::before {
    content: '';
    position: absolute;
    width: 24px;
    height: 24px;
    border: 2px solid rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

/* 中心圆点（未激活态） */
::v-deep .my-bullet::after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

/* 左侧横向线段（未激活态） */
::v-deep .my-bullet .line-left {
    position: absolute;
    width: 50px;
    height: 1px;
    background: rgba(255, 255, 255, 0.2);
    top: 50%;
    right: calc(50% + 12px);
    /* 与环形左侧衔接 */
    transform: translateY(-50%);
    left: -60px;
    display: none;
}

/* 右侧横向线段（未激活态） */
::v-deep .my-bullet .line-right {
    position: absolute;
    width: 50px;
    height: 1px;
    background: rgba(255, 255, 255, 0.2);
    top: 50%;
    left: calc(50% + 12px);
    /* 与环形右侧衔接 */
    transform: translateY(-50%);
    left: 45px;
}

// ::v-deep .line-right:last-child {
//     display: none;
// }
/* 隐藏最后一个指示器的右侧线段 */
::v-deep .my-bullet:last-child .line-right {
    display: none;
}

/* 激活态样式：颜色加深、尺寸放大 */
::v-deep .my-bullet-active::before {
    border-color: #ffffff;
    width: 28px;
    height: 28px;
    /* 环形放大 */
}

::v-deep .my-bullet-active::after {
    background: #ffffff;
    width: 10px;
    height: 10px;
    /* 圆点放大 */
}

::v-deep .my-bullet-active .line-right {
    background: #ffffff;

    /* 线段变色 */
}

</style>